import { useEffect, useState } from 'react';
import { login } from '../services/apiService';
import { useNavigate } from 'react-router-dom';

const QUOTES = [
  '"Every dollar saved is a dollar you control."',
  '"Budgets are dreams with dates."',
  '"Track the cents, and the dollars follow."',
  '"Expenses tell the story before the balance does."',
  '"Small tweaks beat big overhauls."',
  '"Protect the bottom line - one decision at a time."',
];

const getRandomQuote = () => QUOTES[Math.floor(Math.random() * QUOTES.length)];

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [quote, setQuote] = useState(getRandomQuote);
  const [now, setNow] = useState(new Date());
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await login(email, password);

      if (response.data.success) {
        localStorage.setItem('token', response.data.token);
        navigate('/'); // Redirect to home page after login
      } else {
        setError(response.data.error || 'Invalid email or password');
      }
    } catch (err) {
      setError('An unexpected error occurred. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const ticker = setInterval(() => setNow(new Date()), 1000);
    const quoteCycle = setInterval(() => setQuote(getRandomQuote), 12000);
    return () => {
      clearInterval(ticker);
      clearInterval(quoteCycle);
    };
  }, []);

  const clock = now.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#f5f7fb',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2.5rem',
        color: '#0f172a',
      }}
    >
      <div
        className="container"
        style={{
          background: '#ffffff',
          border: '1px solid #e5e7eb',
          boxShadow: '0 24px 60px rgba(15, 23, 42, 0.08)',
          borderRadius: '22px',
          overflow: 'hidden',
          padding: 0,
        }}
      >
        <div className="row g-0">
          <div
            className="col-lg-7 d-flex flex-column justify-content-between"
            style={{
              background: 'linear-gradient(135deg, #eef2ff, #f8fafc)',
              padding: '3rem',
            }}
          >
            <div>
              <p
                style={{
                  display: 'inline-block',
                  padding: '0.45rem 0.95rem',
                  borderRadius: '12px',
                  background: '#e0f2fe',
                  color: '#0f172a',
                  letterSpacing: '0.06em',
                  fontSize: '0.85rem',
                  textTransform: 'uppercase',
                  border: '1px solid #bae6fd',
                }}
              >
                Expense Command Center
              </p>
              <h1 style={{ fontWeight: 800, marginTop: '1.1rem', color: '#0f172a', letterSpacing: '-0.02em' }}>
                KYE Control Panel
              </h1>
              <p style={{ fontSize: '1.05rem', color: '#475569', maxWidth: '34rem' }}>
                Make sharper decisions with live spend signals, anomaly alerts, and a clean overview of every rupee. Welcome back to the cockpit.
              </p>
            </div>

            <div
              style={{
                border: '1px solid #e2e8f0',
                borderRadius: '14px',
                padding: '1.35rem',
                background: '#ffffff',
                boxShadow: '0 12px 28px rgba(15, 23, 42, 0.06)',
              }}
            >
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                  <p className="mb-1" style={{ color: '#475569', letterSpacing: '0.04em' }}>
                    Control Room Clock
                  </p>
                  <div style={{ fontSize: '2rem', fontWeight: 700, color: '#0f172a' }}>{clock}</div>
                </div>
               
              </div>
              <div
                style={{
                  borderTop: '1px solid #e2e8f0',
                  paddingTop: '1rem',
                  color: '#0f172a',
                  lineHeight: 1.5,
                }}
              >
                {quote}
                <div style={{ marginTop: '0.35rem', color: '#64748b', fontSize: '0.9rem' }}>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-5">
            <div
              className="h-100"
              style={{
                background: '#ffffff',
                padding: '3rem 2.5rem',
              }}
            >
              <div className="mb-4 text-center">
                <h3 style={{ fontWeight: 800, color: '#0f172a', letterSpacing: '-0.01em' }}>Secure Sign In</h3>
                <p style={{ color: '#475569', marginBottom: 0 }}>
                  Access budgets, approvals, and live expense streams.
                </p>
              </div>
              {error && <div className="alert alert-danger">{error}</div>}
              <form onSubmit={handleLogin}>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label" style={{ color: '#0f172a' }}>Email address</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    placeholder="name@example.com"
                    style={{ backgroundColor: '#f8fafc', color: '#0f172a', borderColor: '#e2e8f0' }}
                  />
                </div>
                <div className="mb-4">
                  <label htmlFor="password" className="form-label" style={{ color: '#0f172a' }}>Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    placeholder="Password"
                    style={{ backgroundColor: '#f8fafc', color: '#0f172a', borderColor: '#e2e8f0' }}
                  />
                </div>
                <div className="d-grid">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                    style={{
                      background: 'linear-gradient(135deg, #2563eb, #22c55e)',
                      border: 'none',
                      fontWeight: 800,
                      letterSpacing: '0.01em',
                      boxShadow: '0 12px 30px rgba(37, 99, 235, 0.2)',
                    }}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <span className="visually-hidden">Loading...</span>
                      </>
                    ) : (
                      'Enter Control Center'
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
